import { Outlet } from 'react-router-dom';
import { DpPortalHeader } from '../DpPortalHeader';
import { DpPortalSkeleton } from '../DpPortalSkeleton';
import { useDpPortalTabs } from '../../hooks/useDpPortalTabs';

export function DpPortalLayout() {
    const { isLoading } = useDpPortalTabs();

    if (isLoading) {
        return <DpPortalSkeleton />;
    }

    return (
        <div className="space-y-8 pb-12">
            <DpPortalHeader />
            <Outlet />
        </div>
    );
}
